import { LinkText } from 'components/shared/LinkText';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/dist/client/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { StyledContainer, StyledSection } from './PrivacyPolicyDetails.styled';

const PrivacyPolicyDetails: React.FC = () => {
  const { t } = useI18n('privacyPolicy');
  const { locale } = useRouter();

  return (
    <StyledSection>
      <StyledContainer>
        <div>
          <Heading2 editorial>{t('details.title')}</Heading2>
          <p>
            <Trans
              ns={'privacyPolicy'}
              i18nKey={'details.desc'}
              components={{
                mail: (
                  <a href="mailto:hello@getmanfred.com">hello@getmanfred.com</a>
                ),
                team: <LinkText href={getAppUrl(APP_URLS.team, locale)} />
              }}
            ></Trans>
          </p>
        </div>
        <img
          src={getPublicPath('/images/privacyPolicy/details-img.png')}
          alt=""
        />
      </StyledContainer>
    </StyledSection>
  );
};

export default PrivacyPolicyDetails;
